import { apiClient } from "../../utils/apiClient";
import { Building } from "../../types/building";

export const fetchBuildings = (): Promise<Building[]> => {
    return apiClient.get("/buildings").then((response) => response.data);
};

export const upsertBuilding = (building: Building): Promise<Building> => {
    return apiClient.post("/buildings/upsertBuilding", building).then((response) => response.data);
};

export const getBuildingByName = (buildingName: string): Promise<Building> => {
    return apiClient.get(`/buildings/name/${buildingName}`).then((response) => response.data);
};